import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    body{
        background-color: #c4c4c4 !important;
    }
    .isReady {
    background: aliceblue !important;
  }
`;

export default GlobalStyle;
